import React from "react"

type Props = {
  title: string
  favicon: any
}

const Meta = ({ title, favicon }: Props) => {
  return (
    <>
      <title>{title}</title>
      <link
        id="favicon"
        rel="icon"
        type="image/svg"
        href={favicon}
        sizes="16x16"
      />
    </>
  )
}

export default Meta
